import Vue from "vue";
import Vuex from "vuex";



Vue.use(Vuex);


const state = () => ({
    blogData: null,
    previousPage: 1
})

const getters = {

}

const actions = {

}

const mutations = {
    SET_PREVIOUS_PAGE(state, value) {
        state.previousPage = value;
    },
    SET_BLOG_DATA(state, value) {
        state.blogData = value;
    },
}


export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}

